import { LinkOff } from "@mui/icons-material";

import { InfoPage } from "../../../shared/components/info-page/info-page";
import { InfoPageIllustration } from "../../../shared/components/info-page/info-page-illustration";
import { InfoPageLayout } from "../../../shared/components/info-page/info-page-layout";
import { SignInButton } from "../components/sign-in-button";

/** Сюда BFF IMS уводит браузер, когда колбэк входа не удался. Точная причина неизвестна. */
export const RemoteFailurePage = (): JSX.Element => (
  <InfoPageLayout>
    <InfoPage
      title="Не удалось войти"
      message="Вход прервался. Попробуйте войти ещё раз"
      illustration={<InfoPageIllustration icon={LinkOff} />}
      actions={<SignInButton />}
    />
  </InfoPageLayout>
);
